import React from "react";
import Markdown from "../../MarkDown";

import "./index.less";
import { openNewPage } from "@/utils";
import { Tooltip } from "antd";
// import { useAppSelector } from "@/store";

export default function KnowledgeAnswer(props: { data: KnowledgeRetrievalOutput; onExpandSource: () => void }) {
  const { data, onExpandSource } = props;
  // const isInPC = useAppSelector((state) => state.app.isInPC);
  const isInPC = true

  return (
    <>
      {data.outputs.result?.length ? (
        // <div className="chat-block__middle-text__reference">已检索{data.outputs.result.length}个文档</div>
        <>
          <div className="answer-source">
            <div className="answer-source__label">
              来源
              <span style={{ fontWeight: 400, color: "#a1a1a1", marginLeft: 6 }}>
                (共{data.outputs.result.length}个)
              </span>
            </div>
            <div className="answer-source__all" onClick={onExpandSource}>
              查看全部
            </div>
          </div>
          {isInPC ? (
            <div className="answer-source__list">
              {data.outputs.result.slice(0, 4).map((reference, idx) => {
                return (
                  <div
                    className="answer-source__list-item"
                    key={reference.title + idx}
                    onClick={() => openNewPage(reference)}
                  >
                    <Tooltip placement="top" title={reference.title}>
                      <div className="one-line-ellipsis">{reference.title}</div>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="answer-source__list-mobile">
              {data.outputs.result!.map((reference, idx) => {
                return (
                  <div
                    className="answer-source__list-mobile-item one-line-ellipsis"
                    key={reference.title + idx}
                    onClick={() => openNewPage(reference)}
                  >
                    {reference.title}
                  </div>
                );
              })}
            </div>
          )}
        </>
      ) : null}
      <div className="answer-source">
        <div className="answer-source__label">总结</div>
      </div>
      <Markdown content={data.outputs.summary} />
    </>
  );
}
